import React from 'react';

// Fixed-width polyline, scaled to its own max. Nulls (gaps in polling) are
// drawn as breaks rather than zeros so a dropped sample doesn't look like idle.
export default function Sparkline({ values, max, width = 120, height = 24, className = '' }) {
  const peak = max ?? Math.max(1, ...values.filter(v => v != null));
  const step = values.length > 1 ? width / (values.length - 1) : width;
  const d = values
    .map((v, i) => (v == null ? null : `${(i * step).toFixed(1)},${(height - (v / peak) * height).toFixed(1)}`))
    .reduce((acc, pt, i, arr) => {
      if (pt == null) return acc;
      const prev = arr[i - 1];
      return acc + (prev == null ? `M${pt}` : `L${pt}`);
    }, '');
  return (
    <svg className={`df-spark ${className}`} viewBox={`0 0 ${width} ${height}`} width={width} height={height} aria-hidden="true">
      <path d={d} fill="none" vectorEffect="non-scaling-stroke" />
    </svg>
  );
}
